import { z } from "zod";
import { PlanInterest } from "@/enum/common.enum";

export const contactInquirySchema = z.object({
  name: z.string().trim().min(2, "Name is required."),
  email: z.string().trim().min(1, "Email is required.").email("Enter a valid email address."),
  company: z.string().trim().optional(),
  team_size: z.string().trim().optional(),
  plan_interest: z.nativeEnum(PlanInterest),
  message: z.string().trim().max(2_000, "Keep the message under 2,000 characters.").optional(),
});

export type ContactInquiryValues = z.infer<typeof contactInquirySchema>;
